let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lvMC0")).then(() => parcelRequire('iTHKU'));